import React from 'react';
import QueryDetails from './querydetails';
import ComplaintTable from './complainttable';
import './complaintmanagement.css';

const ShowTablePage = () => {
  return (
    <main className="ca-query-management-page">
      <QueryDetails />
      <ComplaintTable />
    </main>
  );
};

export default ShowTablePage;